import { useAuth } from '@state'
import { Crosshair, Eye, PencilLine } from 'lucide-solid'
import { createEffect } from 'solid-js'
import { Show } from 'solid-js/web'
import { useService } from 'solid-services'
import { useChannelsReads } from '../../../../../state/channelReads/state'
import { useCreate } from '../../../Create/state'
import { useSingle } from '../../state'
import Action from './Action'
import { Score } from './Score'

const Actions = () => {
	const { toggleTaken, takenResource, subscribed, isArchived } = useService(useSingle)()
	const { setupResource } = useService(useSingle)()
	const { channelReadsRefetch, channelSeenResource, toggleSubscribed } =
		useService(useChannelsReads)()

	const takenText = () =>
		takenResource()?.has_taken
			? 'You have taken this setup'
			: 'Mark this setup as taken'
	const watchText = () =>
		subscribed() ? 'You are subscribed this setup' : 'Mark this setup as subscribed'

	const takenHeading = () => (takenResource()?.has_taken ? 'Taken' : 'Take')
	const watchHeading = () => (subscribed() ? 'Subscribed' : 'Subscribe')

	createEffect(() => {
		if (channelSeenResource.state === 'ready') {
			channelReadsRefetch()
		}
	})

	return (
		<>
			<Action
				heading={watchHeading()}
				text={watchText()}
				disabled={isArchived()}
				loading={channelSeenResource.loading}
				active={!!subscribed()}
				onClick={() => toggleSubscribed(setupResource()?.channel_id || undefined)}
				icon={<Eye />}
			/>
			<Action
				heading={takenHeading()}
				text={takenText()}
				disabled={isArchived()}
				loading={takenResource.loading}
				active={takenResource()?.has_taken}
				onClick={toggleTaken}
				icon={<Crosshair />}
			/>
			<Score />
		</>
	)
}

export default Actions
